import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Snackbar extends Vue {
    get snackbar() {
        return this.$store.getters.snackbar
    }

    get visible() {
        return this.snackbar.visible
    }

    set visible(val: any) {
        if (!val) this.$store.commit('closeSnackbar')
    }

    closeSnackbar() {
        this.$store.commit('closeSnackbar')
    }

    showMore = true

    get color() {
        return this.snackbar
            ? this.snackbar.type == 'success'
                ? 'blue-grey darken-3'
                : this.snackbar.type
            : 'transparent'
    }
}
